import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translation_en from './en';
import translation_es from './es';
import translation_fr from './fr';
import translation_ge from './ge';
import translation_it from './it';
import translation_jp from './jp';
import translation_sc from './sc';
import translation_tc from './tc';
import translation_ar from './ar';

const resources = {
    en: {
        translation: translation_en
    },
    es: {
        translation: translation_es
    },
    fr: {
        translation: translation_fr
    },
    ge: {
        translation: translation_ge
    },
    it: {
        translation: translation_it
    },
    jp: {
        translation: translation_jp
    },
    sc: {
        translation: translation_sc
    },
    tc: {
        translation: translation_tc
    },
    ar: {
        translation: translation_ar
    },
};

// console.log('i18n init')
i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "en", // 默认语言
        fallbackLng: "en", // 当当前语言的翻译缺失时回退到该语言
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;


// WEBPACK FOOTER //
// ./src/locales/index.js